import join from 'url-join';

import { CommercialBankingCategory } from '@app/queryTyping';

import { PageURL } from '@app/core/widgets/pages';

export const RECIPIENT_ID_PARAM = 'recipientId';
export const TEMPLATE_ID_PARAM = 'templateId';
export const TAB_INDEX_SEARCH_PARAM = 'tab';
export const PARENT_USER_PARAM = 'parentUserId';

const getUrl = (page: string, attachTo: string = PageURL.BUSINESS_BANKING) => join(attachTo, page);
export const BUSINESS_BANKING_PAGE_NOT_FOUND = getUrl('/*');
export const CASH_MANAGEMENT_ROOT = getUrl('cash-management');
export const PARENT_CASH_MANAGEMENT_ROOT = getUrl(`cash-management/parent/:${PARENT_USER_PARAM}`);

const generateCashManagementRoutes = (ROOT: string) => {
  const NOT_FOUND = getUrl('/*', ROOT);
  const RECIPIENTS = getUrl('recipients', ROOT);
  const ADD_NEW_RECIPIENT = getUrl('/new', RECIPIENTS);
  const RECIPIENT_DETAILS = getUrl(`/recipient/:${RECIPIENT_ID_PARAM}`, RECIPIENTS);
  const EDIT_RECIPIENT = getUrl(`/recipient/edit/:${RECIPIENT_ID_PARAM}`, RECIPIENTS);
  const TEMPLATES = getUrl('templates', ROOT);
  const ADD_NEW_TEMPLATE = getUrl('/new', TEMPLATES);
  const TEMPLATE_DETAILS = getUrl(`/template/:${TEMPLATE_ID_PARAM}`, TEMPLATES);
  const EDIT_TEMPLATE = getUrl(`/template/edit/:${TEMPLATE_ID_PARAM}`, TEMPLATES);

  return {
    CASH_MANAGEMENT: ROOT,
    NOT_FOUND,
    RECIPIENTS,
    ADD_NEW_RECIPIENT,
    EDIT_RECIPIENT,
    RECIPIENT_DETAILS,
    TEMPLATES,
    ADD_NEW_TEMPLATE,
    TEMPLATE_DETAILS,
    EDIT_TEMPLATE,
  };
};

// instead of enum, cause can't use computed values as value for enum keys
export const CashManagementPages = generateCashManagementRoutes(CASH_MANAGEMENT_ROOT);
export const ParentCashManagementPages = generateCashManagementRoutes(PARENT_CASH_MANAGEMENT_ROOT);

export type CashManagementRoutesConfiguration = ReturnType<typeof generateCashManagementRoutes>;

type AllowedTab = CommercialBankingCategory.PAYMENTS
| CommercialBankingCategory.RECEIPTS
| CommercialBankingCategory.PAYROLL;
export const CORRECT_TEMPLATE_TAB_ORDER: AllowedTab[] = [
  CommercialBankingCategory.PAYMENTS,
  CommercialBankingCategory.RECEIPTS,
  CommercialBankingCategory.PAYROLL,
];

export const ACH_HISTORY_YEAR_PARAM = 'year';
export const ACH_HISTORY_ROOT = getUrl('transaction-activity');
export const ACH_HISTORY_SELECT_YEAR = getUrl('select-year', ACH_HISTORY_ROOT);
export const ACH_HISTORY_DOWNLOAD_REPORT = getUrl(
  `download-report/year/:${ACH_HISTORY_YEAR_PARAM}`,
  ACH_HISTORY_ROOT,
);
export const ACH_PARENT_HISTORY_DOWNLOAD_REPORT = getUrl(
  `download-report/parent/:${PARENT_USER_PARAM}/year/:${ACH_HISTORY_YEAR_PARAM}`,
  ACH_HISTORY_ROOT,
);
